import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const BookingPluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default BookingPluginPage